<template>
  <div class="b2b-container">
    <div class="b2b-navbar">
      <div class="version-box">
        <div class="switch" type="text" @click="gotoNewHome">
          {{ $t("B2B.header10") }}
        </div>
      </div>
      <div class="switch-box">
        <div class="switch" type="text" @click="openVancheen">
          {{ $t("B2B.header1") }}
        </div>
      </div>
      <div class="admin-box">
        <div class="logout" type="text" @click="logoutAdmin" v-if="isAdminLogin()">
          {{ $t("B2B.header3") }}
        </div>
        <div class="login" type="text" @click="gotoAminLogin" v-else>
          {{ $t("B2B.header2") }}
        </div>
      </div>
      <div class="supplier-box">
        <div class="logout" type="text" @click="gotoUserPage" v-if="isLogin() && loginType() == 'SU'">
          {{ $t("B2B.header5") }}
        </div>
        <div class="login" type="text" @click="gotoSupplierLogin" v-else>
          {{ $t("B2B.header4") }}
        </div>
      </div>
      <div class="language-box">
        <div class="text" @click="handleSetLanguage('en')" v-if="getLang() === 'zh'">
          English
        </div>
        <div class="text" @click="handleSetLanguage('zh')" v-else>中文</div>
      </div>
    </div>
    <div class="b2b-header">
      <div class="logo" @click="openHome">
        <img src="../../assets/img/b2b-navbar-logo.png" />
      </div>
      <div class="menus">
        <div class="menus-custom" @mouseenter="activityVisible = true" @mouseleave="activityVisible = false">
          <span class="custom-title arrow1">{{ $t("B2B.navbar1") }}</span>
          <a class="menus-arrow" :style="{ left: arrow1 + 'px' }" v-if="activityVisible"></a>
          <el-collapse-transition>
            <div class="transition-box" v-show="activityVisible">
              <div class="activity-wrapper">
                <div class="activity-title">{{ $t("collapse1.title") }}</div>
                <swiper class="activity-swpier" :options="activityOption">
                  <swiper-slide v-for="(item, index) of activitylist" :key="index" :style="{
                    'background-image':
                      'url(' + imgUrlFilter(item.PosterThumbnail) + ')',
                  }" @click.native="
                    slidesClick(imgUrlFilter(item.ActivityPoster))
                    ">
                    <div class="activity-text">
                      <div class="activity-name" v-if="item.ActivityName">
                        {{ item.ActivityName }}
                      </div>
                      <div class="activity-date" v-if="item.ActivityDate">
                        {{ item.ActivityDate }}
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="menus-custom-dropdown">
          <el-menu mode="horizontal" text-color="#000" active-text-color="#000">
            <el-submenu index="1">
              <template slot="title"><span class="header">{{ $t("B2B.navbar2") }}</span>
              </template>
              <div v-for="(item1, idx1) of classList" :key="idx1">
                <template v-if="item1.SubClassList && item1.SubClassList.length > 0">
                  <el-submenu :index="'1-' + (idx1 + 1)">
                    <template slot="title"><span class="name">{{ item1.ClassName }}</span></template>
                    <div v-for="(item2, idx2) of item1.SubClassList" :key="idx2">
                      <template v-if="
                        item2.SubClassList && item2.SubClassList.length > 0
                      ">
                        <el-submenu :index="'1-' + (idx1 + 1) + '-' + (idx2 + 1)">
                          <template slot="title"><span class="name">{{
                            item2.ClassName
                              }}</span></template>
                          <div v-for="(item3, idx3) of item2.SubClassList" :key="idx3">
                            <el-menu-item :index="'1-' +
                              (idx1 + 1) +
                              '-' +
                              (idx2 + 1) +
                              '-' +
                              (idx3 + 1)
                              " @click="menuSelect(item3.BPCId, item3.ClassName)"><span class="name">{{
                                item3.ClassName
                              }}</span></el-menu-item>
                          </div>
                        </el-submenu>
                      </template>
                      <template v-else>
                        <el-menu-item :index="'1-' + (idx1 + 1) + '-' + (idx2 + 1)"
                          @click="menuSelect(item2.BPCId, item2.ClassName)"><span class="name">{{
                            item2.ClassName
                          }}</span></el-menu-item>
                      </template>
                    </div>
                  </el-submenu>
                </template>
                <template v-else>
                  <el-menu-item :index="'1-' + (idx1 + 1)" @click="menuSelect(item1.BPCId, item1.ClassName)"><span
                      class="name">{{
                        item1.ClassName
                      }}</span></el-menu-item>
                </template>
              </div>
            </el-submenu>
          </el-menu>
        </div>
        <div class="menus-custom" @mouseenter="consultVisible = true" @mouseleave="consultVisible = false">
          <span class="custom-title arrow2">{{ $t("B2B.navbar3") }}</span>
          <a class="menus-arrow" :style="{ left: arrow2 + 'px' }" v-if="consultVisible"></a>
          <el-collapse-transition>
            <div class="transition-box" v-show="consultVisible">
              <div class="consult-wrapper">
                <div class="help">
                  <div class="help-title">
                    {{ $t("collapse2.title") }}
                  </div>
                  <div class="help-content">
                    <sidePane :tab-list="tabNav" :active="activeTab" class="m-20" @updateActive="updateTabNav">
                      <div slot="first">
                        <el-collapse v-model="activeCollapse">
                          <el-collapse-item :title="$t('collapse2.tab1Title1')" name="1"><span>
                              {{ $t("collapse2.tab1Content1.t1")
                              }}<span class="help-event" @click="toShippingRules">
                                {{ $t("collapse2.tab1Content1.t2") }} </span>{{ $t("collapse2.tab1Content1.t3") }}
                            </span>
                          </el-collapse-item>
                          <el-collapse-item :title="$t('collapse2.tab1Title2')" name="2">
                            <div>
                              {{ $t("collapse2.tab1Content2.t1") }}
                            </div>
                            <div>
                              {{ $t("collapse2.tab1Content2.t2") }}
                            </div>
                          </el-collapse-item>
                          <el-collapse-item :title="$t('collapse2.tab1Title3')" name="3"><span>
                              {{ $t("collapse2.tab1Content3.t1") }}
                            </span>
                          </el-collapse-item>
                          <el-collapse-item :title="$t('collapse2.tab1Title4')" name="4">
                            <div>
                              {{ $t("collapse2.tab1Content4.t1") }}
                            </div>
                            <div>
                              {{ $t("collapse2.tab1Content4.t2")
                              }}<span class="help-event" @click="toFeedback">
                                {{ $t("collapse2.tab1Content4.t3") }}</span>
                              {{ $t("collapse2.tab1Content4.t4") }}
                            </div>
                            <div>
                              {{ $t("collapse2.tab1Content4.t5")
                              }}<span class="help-event" @click="emailLink">info@prolinker.top</span>
                            </div>
                            <div>
                              {{ $t("collapse2.tab1Content4.t6") }}
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                      <div slot="second">
                        <div class="help-empty">
                          {{ $t("collapse2.noData") }}
                        </div>
                      </div>
                      <div slot="third">
                        <div class="help-empty">
                          {{ $t("collapse2.noData") }}
                        </div>
                      </div>
                      <div slot="fourth">
                        <div class="help-empty">
                          {{ $t("collapse2.noData") }}
                        </div>
                      </div>
                      <div slot="fifth">
                        <div class="help-empty">
                          {{ $t("collapse2.noData") }}
                        </div>
                      </div>
                    </sidePane>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="menus-custom" @mouseenter="aboutVisible = true" @mouseleave="aboutVisible = false">
          <span class="custom-title arrow3">{{ $t("B2B.navbar4") }}</span>
          <a class="menus-arrow" :style="{ left: arrow3 + 'px' }" v-if="aboutVisible"></a>
          <el-collapse-transition>
            <div class="transition-box" v-show="aboutVisible">
              <div class="about-wrapper">
                <img class="image" :src="aboutImage" />
                <div class="blocker">
                  <div class="blocker-black">
                    <div class="blocker-title">
                      {{ $t("collapse3.title1") }}
                    </div>
                    <div class="blocker-content">
                      {{ $t("collapse3.content1") }}
                    </div>
                  </div>
                  <div class="blocker-white">
                    <div class="blocker-title">
                      {{ $t("collapse3.title2") }}
                    </div>
                    <div class="blocker-content">
                      {{ $t("collapse3.content2") }}
                    </div>
                  </div>
                  <div class="blocker-green">
                    <div class="blocker-title">
                      {{ $t("collapse3.title3") }}
                    </div>
                    <div class="blocker-content">
                      {{ $t("collapse3.content3") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <div class="cornerBox">
        <div class="searchBox" @click="gotoCatalog">
          <div class="searchIcon">
            <i class="el-icon-search"></i>
            <span>{{ $t("B2B.navbar5") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="thumb-example">
        <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
          <template v-if="isSlidesEdit">
            <swiper-slide v-for="(item, index) of advertList" :key="index" :id="index" :style="{
              'background-image': 'url(' + imgUrlFilter(item.UploadUrl) + ')',
            }">
              <div :class="getLang() == 'en' ? 'titleEn' : 'title'" data-swiper-parallax="-300"
                data-swiper-parallax-opacity="0" v-if="item.Title">
                <span v-if="getLang() == 'en'">{{ item.TitleEn }}</span>
                <span v-else>{{ item.Title }}</span>
              </div>
              <div class="desc" data-swiper-parallax-y="-100" data-swiper-parallax-opacity="0" v-if="item.Description">
                <span v-if="getLang() == 'en'">{{ item.DescriptionEn }}</span>
                <span v-else>{{ item.Description }}</span>
              </div>
            </swiper-slide>
          </template>
          <template v-else>
            <swiper-slide v-for="(item, index) of adverts" :key="index" :id="index" :style="{
              'background-image': 'url(' + imgUrlFilter(item.UploadUrl) + ')',
            }">
              <div :class="getLang() == 'en' ? 'titleEn' : 'title'" data-swiper-parallax="-300"
                data-swiper-parallax-opacity="0" v-if="item.Title">
                {{ item.Title }}
              </div>
              <div class="desc" data-swiper-parallax-y="-100" data-swiper-parallax-opacity="0" v-if="item.Description">
                {{ item.Description }}
              </div>
            </swiper-slide>
          </template>
        </swiper>
        <swiper class="swiper gallery-thumbs" :options="swiperThumbsAll" ref="swiperThumbsAll" v-if="isSlidesEdit">
          <swiper-slide v-for="(item, index) of advertList" :key="index" :style="{
            'background-image': 'url(' + imgUrlFilter(item.Thumbnail) + ')',
          }" class="swpier-edit">
            <div class="slides-buttons">
              <div class="slides-wrapper">
                <el-dropdown class="slides-dropdown" placement="bottom" @command="commandSlides(item, $event)">
                  <span class="el-dropdown-link">
                    <i class="el-icon-s-tools" v-if="item.IsDisplay"></i>
                    <i class="el-icon-setting" v-else></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="state">
                      <span v-if="item.IsDisplay">{{ $t("B2B.hidden") }}</span>
                      <span v-else>{{ $t("B2B.display") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="edit">{{
                      $t("B2B.edit")
                    }}</el-dropdown-item>
                    <el-dropdown-item command="delete">{{
                      $t("B2B.delete")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <swiper class="swiper gallery-thumbs" :options="swiperThumbs" ref="swiperThumbs" v-else>
          <swiper-slide v-for="(item, index) of adverts" :key="index" :style="{
            'background-image': 'url(' + imgUrlFilter(item.Thumbnail) + ')',
          }">
          </swiper-slide>
        </swiper>
        <div class="buttons" v-if="isAdminLogin()">
          <el-button-group v-if="isSlidesEdit">
            <el-button type="default" @click="slidesEditCancel">{{
              $t("B2B.cancelEdit")
            }}</el-button>
            <el-button type="primary" @click="slidesShow('new')">{{
              $t("B2B.createSlides")
            }}</el-button>
          </el-button-group>
          <el-button type="primary" @click="slidesEdit" v-else>{{
            $t("B2B.editSlides")
          }}</el-button>
        </div>
      </div>

      <div class="calendar">
        <div class="calendar-title">
          {{ $t("B2B.title1") }}
        </div>
        <div class="calendar-left">
          <el-calendar v-model="calendarValue">
            <template slot="dateCell" slot-scope="{ data }">
              <div style="margin: 0; position: relative">
                <div class="dateText">
                  {{ data.day.split("-").slice(2).join() }}
                </div>
                <div v-for="(i, index) in dayTime" :key="index" class="budge-wrapper">
                  <div v-if="data.day == i" class="budge"></div>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
        <div class="calendar-right">
          <div class="scroll-box">
            <div class="scroll-title">{{ $t("B2B.subTitle1") }}</div>
            <div class="scroll-content">
              <div :class="[
                currentDate == item.ActivityDate ? 'activity-select' : '',
                'activity',
              ]" :id="item.ActivityDate" v-for="(item, index) of activitylist" :key="index">
                <div class="left">
                  <el-image ref="activityPoster" fit="cover" :src="imgUrlFilter(item.PosterThumbnail)"
                    :preview-src-list="[imgUrlFilter(item.ActivityPoster)]">
                  </el-image>
                </div>
                <div class="right">
                  <div class="top">
                    <!-- :style="{ color: item.isHk ? '#137c60' : '#4F5177' }" -->
                    <span>{{ item.ActivityDate }}</span>
                  </div>
                  <div class="bottom">
                    <span>{{ item.ActivityName }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="scroll-footer">
              <el-button type="warning" plain round>
                浏览更多活动
              </el-button>
            </div> -->
          </div>
        </div>
      </div>

      <div class="sec-break"></div>

      <div class="category" v-if="classList && classList.length > 0">
        <div class="category-title">
          {{ $t("B2B.title2") }}
        </div>
        <div class="category-content">
          <div class="category-background"></div>
          <div class="category-container">
            <div class="category-wrapper" v-if="isClassEdit">
              <div class="category-editItem" v-for="(item, index) of classList" :key="index" :id="'item' + (index + 1)">
                <el-image class="image" :src="imgUrlFilter(item.ClassIcon)">
                  <template v-slot:error>
                    <img class="image" :src="classListDefault[index].image" />
                  </template>
                </el-image>
                <div class="editItem-buttons">
                  <div class="editItem-wrapper">
                    <el-dropdown class="editItem-dropdown" placement="bottom" @command="commandClass(item, $event)">
                      <span class="el-dropdown-link">
                        <i class="el-icon-s-tools"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="edit">{{
                          $t("B2B.edit")
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="category-wrapper" v-else>
              <div class="category-item" v-for="(item, index) of classList" :key="index" :id="'item' + (index + 1)"
                @click="cateogrySelect(item.BPCId, index)">
                <div class="title">
                  <span class="text">{{ item.ClassName }}</span>
                  <i class="el-icon-right"></i>
                </div>
                <el-image class="image" :src="imgUrlFilter(item.ClassIcon)">
                  <template v-slot:error>
                    <img class="image" :src="classListDefault[index].image" />
                  </template>
                </el-image>
              </div>
            </div>
          </div>
          <div class="category-buttons" v-if="isAdminLogin()">
            <el-button-group v-if="isClassEdit">
              <el-button type="default" @click="classEditCancel">{{
                $t("B2B.cancelEdit")
              }}</el-button>
            </el-button-group>
            <el-button type="primary" @click="classEdit" v-else>{{
              $t("B2B.editIcon")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright">
      <div class="text1">迎客商服控股（广州）有限公司版权所有</div>
      <a class="text2" href="https://beian.miit.gov.cn" target="blank">粤ICP备20012225号-1</a>
    </div>

    <el-dialog :title="dialogClassType == 'new' ? $t('B2B.createClass') : $t('B2B.editClass')
      " width="30%" :visible.sync="classVisible" :close-on-click-modal="false">
      <el-form ref="classForm" :model="classForm" :rules="classRules" label-width="80px" label-position="left">
        <el-form-item :label="$t('B2B.classIcon')" prop="UploadUrl">
          <uploader style="margin-top: 10px" :urls="classForm.UploadUrl" :max="1" :type="'photo'"
            @change="handleClassChanged" ref="classUploader"></uploader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classClose">{{ $t("B2B.cancel") }}</el-button>
        <el-button type="primary" @click="classSubmit">{{
          $t("B2B.submit")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogSlidesType == 'new' ? $t('B2B.createAd') : $t('B2B.editAd')" width="30%"
      :visible.sync="slidesVisible" :close-on-click-modal="false">
      <el-form ref="slidesForm" :model="slidesForm" :rules="slidesRules" label-width="120px" label-position="left">
        <el-form-item :label="$t('B2B.title')" prop="Title">
          <el-input v-model="slidesForm.Title" :placeholder="$t('B2B.input')" />
        </el-form-item>
        <el-form-item :label="$t('B2B.titleEn')" prop="TitleEn">
          <el-input v-model="slidesForm.TitleEn" :placeholder="$t('B2B.input')" />
        </el-form-item>
        <el-form-item :label="$t('B2B.desc')" prop="Description">
          <el-input v-model="slidesForm.Description" type="textarea" :autosize="{ minRows: 3 }"
            :placeholder="$t('B2B.input')" />
        </el-form-item>
        <el-form-item :label="$t('B2B.descEn')" prop="DescriptionEn">
          <el-input v-model="slidesForm.DescriptionEn" type="textarea" :autosize="{ minRows: 3 }"
            :placeholder="$t('B2B.input')" />
        </el-form-item>
        <el-form-item :label="$t('B2B.poster')" prop="UploadUrl">
          <uploader style="margin-top: 10px" :urls="slidesForm.UploadUrl" :max="1" :type="'photo'"
            @change="handleSlidesChanged" ref="slidesUploader"></uploader>
        </el-form-item>
        <el-form-item :label="$t('B2B.link')" prop="JumpLink">
          <el-input v-model="slidesForm.JumpLink" :placeholder="$t('B2B.input')" />
        </el-form-item>
        <el-form-item :label="$t('B2B.sort')" prop="OrderBy">
          <el-input-number v-model="slidesForm.OrderBy" :min="1" :max="99"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="slidesClose">{{ $t("B2B.cancel") }}</el-button>
        <el-button type="primary" @click="slidesSubmit">{{
          $t("B2B.submit")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="customerDialog" :visible.sync="slidesDeleteVisible" :close-on-click-modal="false" min-width="50%"
      top="35vh" :center="true">
      <div slot="title" class="title">{{ $t("B2B.notice") }}</div>
      <div class="stateInfo">{{ $t("B2B.contentAd") }}</div>
      <div class="btns">
        <el-button style="margin-right: 20px" @click="slidesDeleteClose">{{
          $t("B2B.cancel")
        }}</el-button>
        <el-button type="primary" @click="slidesDelete">{{
          $t("B2B.submit")
        }}</el-button>
      </div>
    </el-dialog>

    <basket></basket>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { ADMIN_LOG_OUT } from "../../store/mutation-types";
import sidePane from "./components/sidePane.vue";
export default {
  name: "b2b",
  components: {
    sidePane,
  },
  data() {
    return {
      activeTab: "first",
      tabNav: [
        {
          label: this.$t("collapse2.tab1"),
          name: "first",
        },
        {
          label: this.$t("collapse2.tab2"),
          name: "second",
        },
        {
          label: this.$t("collapse2.tab3"),
          name: "third",
        },
        {
          label: this.$t("collapse2.tab4"),
          name: "fourth",
        },
        {
          label: this.$t("collapse2.tab5"),
          name: "fifth",
        },
      ],
      activityVisible: false,
      consultVisible: false,
      aboutVisible: false,
      aboutImage: require("@/assets/img/b2b/about.jpg"),
      isSlidesEdit: false,
      isClassEdit: false,
      activityOption: {
        slidesPerView: 1,
        spaceBetween: 50,
        breakpointsBase: "container",
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      swiperOptionTop: {
        loopedSlides: 1, // looped slides should be the same
        autoplay: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 300,
        parallax: true,
        on: {
          click: (e) => {
            var index = e.target.id;
            if (!this.isSlidesEdit)
              this.slidesClick(this.adverts[index].JumpLink);
          },
        },
      },
      swiperThumbs: {
        loopedSlides: 1, // looped slides should be the same
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 0.5,
        slideToClickedSlide: true,
        virtualTranslate: true,
        width: 120,
      },
      swiperThumbsAll: {
        loopedSlides: 1, // looped slides should be the same
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 0.5,
        slideToClickedSlide: true,
        virtualTranslate: true,
        width: 120,
      },
      adverts: [], //展示广告数据
      advertList: [], //全部广告数据
      calendarValue: new Date(),
      currentDate: "",
      activitylist: [], //活动列表
      dayTime: [], //活动日历标记
      classList: [], //展示分类数据
      classListDefault: [
        {
          title: this.$t("B2B.classTitle1"),
          image: require("@/assets/img/b2b/a.jpg"),
        },
        {
          title: this.$t("B2B.classTitle2"),
          image: require("@/assets/img/b2b/b.jpg"),
        },
        {
          title: this.$t("B2B.classTitle3"),
          image: require("@/assets/img/b2b/c.jpg"),
        },
        {
          title: this.$t("B2B.classTitle4"),
          image: require("@/assets/img/b2b/d.jpg"),
        },
        {
          title: this.$t("B2B.classTitle5"),
          image: require("@/assets/img/b2b/e.jpg"),
        },
        {
          title: this.$t("B2B.classTitle6"),
          image: require("@/assets/img/b2b/f.jpg"),
        },
      ],
      activeCollapse: ["1", "2", "3", "4"],
      pageIndex: 1,
      totalCount: 1,
      errorImg:
        'this.src="' + require("@/assets/img/user/img_logo@2x.png") + '"',
      slidesForm: {
        AId: "",
        Title: "",
        TitleEn: "",
        Description: "",
        DescriptionEn: "",
        UploadUrl: [],
        JumpLink: "",
        OrderBy: 1,
      },
      slidesRules: {
        UploadUrl: [
          {
            type: "array",
            required: true,
            message: this.$t("B2B.uploadImage"),
          },
          {
            type: "array",
            min: 1,
            max: 1,
            message: this.$t("B2B.imageLimit"),
          },
        ],
      },
      slidesDeleteVisible: false,
      slidesVisible: false,
      dialogSlidesType: "new",
      classForm: {
        BPCId: "",
        UploadUrl: [],
      },
      classRules: {
        UploadUrl: [
          {
            type: "array",
            required: true,
            message: this.$t("B2B.uploadImage"),
          },
          {
            type: "array",
            min: 1,
            max: 1,
            message: this.$t("B2B.imageLimit"),
          },
        ],
      },
      classVisible: false,
      dialogClassType: "new",
      auth: {},
      arrow1: "",
      arrow2: "",
      arrow3: "",
    };
  },
  computed: {
    ...mapState({
      supplierInfo: (state) => state.supplier.supplierInfo,
    }),
  },
  watch: {
    calendarValue: {
      handler(newVal) {
        var date = this.formatDate(new Date(newVal).toLocaleDateString());
        var scroll = document.getElementsByClassName("scroll-content")[0];
        var element = document.getElementById(date);
        this.currentDate = date;
        if (element) {
          var y = element.offsetTop - scroll.offsetTop;
          scroll.scrollTo({ top: y, behavior: "smooth" });
        }
      },
    },
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("auth")) || {};
    this.arrow1 =
      document.getElementsByClassName("arrow1")[0].offsetLeft +
      document.getElementsByClassName("arrow1")[0].offsetWidth / 3;
    this.arrow2 =
      document.getElementsByClassName("arrow2")[0].offsetLeft +
      document.getElementsByClassName("arrow2")[0].offsetWidth / 3;
    this.arrow3 =
      document.getElementsByClassName("arrow3")[0].offsetLeft +
      document.getElementsByClassName("arrow3")[0].offsetWidth / 3;
  },
  created() {
    this.loadHomeIndex();
  },
  methods: {
    ...mapMutations([ADMIN_LOG_OUT]),
    ...mapActions(["getCUser", "getSupplier", "setLanguage"]),
    isAdminLogin() {
      return this.$store.getters.isAdminLogin;
    },
    loginType() {
      return this.auth.type;
    },
    isLogin() {
      return this.$store.getters.isLogging;
    },
    getLang() {
      return this.$store.getters.getLanguage;
    },
    gotoUserPage() {
      if (this.supplierInfo.B2bMode == 1) {
        this.$router.push("/public");
      } else if (this.supplierInfo.B2b2cMode == 1) {
        this.$router.push("/supplier");
      } else {
        this.$router.push("/activate");
      }
    },
    logoutAdmin() {
      this.ADMIN_LOG_OUT();
      this.$message.success(this.$t("B2B.success"));
    },
    classClose() {
      this.classVisible = false;
    },
    classSubmit() {
      this.$refs["classForm"].validate((valid) => {
        if (valid) {
          const param = {
            BPCId: this.classForm.BPCId,
            ClassIcon: this.classForm.UploadUrl[0],
          };

          this.$api.product
            .updateProductParentClassIcon(param)
            .then(() => {
              this.loadHomeIndex();
              this.classClose();
              this.classEditCancel();
              this.$message.success(this.$t("B2B.success"));
            })
            .catch((error) => {
              this.$message.error(error.message);
            });
        } else {
          return false;
        }
      });
    },
    classEdit() {
      this.isClassEdit = true;
    },
    classEditCancel() {
      this.isClassEdit = false;
    },
    classShow(type, row) {
      if (type == "edit") {
        this.classForm.BPCId = row.BPCId;
        this.classForm.UploadUrl = [row.ClassIcon];
      }
      this.dialogClassType = type;
      this.classVisible = true;
      this.$nextTick((_) => {
        if (this.dialogClassType == "edit") {
          this.$refs.classUploader.reloadData();
        }
      });
    },
    updateTabNav(val) {
      this.activeTab = val;
    },
    commandSlides(item, event) {
      if (event == "state") {
        this.slidesState(item.AId, item.IsDisplay);
      }
      if (event == "edit") {
        this.slidesShow("edit", item);
      }
      if (event == "delete") {
        this.slideDeleteShow(item);
      }
    },
    commandClass(item, event) {
      if (event == "edit") {
        this.classShow("edit", item);
      }
    },
    slidesDeleteClose() {
      this.slidesDeleteVisible = false;
    },
    slideDeleteShow(row) {
      this.slidesForm.AId = row.AId;
      this.slidesDeleteVisible = true;
    },
    slidesClose() {
      this.slidesVisible = false;
    },
    slidesShow(type, row) {
      if (type == "new") {
        this.initSlides();
      }
      if (type == "edit") {
        this.slidesForm.AId = row.AId;
        this.slidesForm.Title = row.Title;
        this.slidesForm.TitleEn = row.TitleEn;
        this.slidesForm.Description = row.Description;
        this.slidesForm.DescriptionEn = row.DescriptionEn;
        this.slidesForm.UploadUrl = [row.UploadUrl];
        this.slidesForm.JumpLink = row.JumpLink;
        this.slidesForm.OrderBy = row.OrderBy;
      }
      this.dialogSlidesType = type;
      this.slidesVisible = true;
      this.$nextTick((_) => {
        if (this.dialogSlidesType == "new") {
          this.$refs.slidesUploader.handleClear();
        }
        if (this.dialogSlidesType == "edit") {
          this.$refs.slidesUploader.reloadData();
        }
      });
    },
    initSlides() {
      this.slidesForm.AId = "";
      this.slidesForm.Title = "";
      this.slidesForm.TitleEn = "";
      this.slidesForm.Description = "";
      this.slidesForm.DescriptionEn = "";
      this.slidesForm.UploadUrl = [];
      this.slidesForm.JumpLink = "";
      this.slidesForm.OrderBy = 1;
    },
    slidesSubmit() {
      this.$refs["slidesForm"].validate((valid) => {
        if (valid) {
          const param = {
            AId: this.slidesForm.AId,
            Title: this.slidesForm.Title,
            TitleEn: this.slidesForm.TitleEn,
            Description: this.slidesForm.Description,
            DescriptionEn: this.slidesForm.DescriptionEn,
            UploadUrl: this.slidesForm.UploadUrl[0],
            JumpLink: this.slidesForm.JumpLink,
            OrderBy: this.slidesForm.OrderBy,
          };
          this.$api.customer
            .saveAdvertInfo(param)
            .then(() => {
              this.loadHomeIndex();
              this.slidesClose();
              this.slidesEditCancel();
              this.$message.success(this.$t("B2B.success"));
            })
            .catch((error) => {
              this.$message.error(error.message);
            });
        } else {
          return false;
        }
      });
    },
    slidesEdit() {
      const swiperTop = this.$refs.swiperTop.$swiper;
      this.isSlidesEdit = true;
      this.getAdvertList();
      this.$nextTick(() => {
        swiperTop.autoplay.stop();
      });
    },
    slidesEditCancel() {
      const swiperTop = this.$refs.swiperTop.$swiper;
      this.isSlidesEdit = false;
      this.$nextTick(() => {
        swiperTop.autoplay.start();
      });
    },
    getAdvertList() {
      let param = {};
      this.$api.customer
        .getAdvertList(param)
        .then((res) => {
          const data = res.data;
          this.advertList = data.reverse();
          if (this.advertList && this.advertList.length > 0) {
            this.setSlidesOptions();
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    slidesDelete() {
      let param = {
        AId: this.slidesForm.AId,
      };
      this.$api.customer
        .deleteAdvertInfo(param)
        .then(() => {
          this.loadHomeIndex();
          this.slidesEditCancel();
          this.slidesDeleteClose();
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    slidesState(id, state) {
      let param = {
        AId: id,
        IsDisplay: state == 1 ? 0 : 1,
      };
      this.$api.customer
        .editAdvertState(param)
        .then(() => {
          this.loadHomeIndex();
          this.slidesEditCancel();
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    slidesClick(url) {
      window.open(url);
    },
    imgUrlFilter(userImgUrl) {
      return this.$api.formatImageUrl(userImgUrl);
    },
    gotoRegister() {
      this.$router.push("/register");
    },
    gotoMessage() {
      this.$router.push("/messageList");
    },
    gotoCatalog() {
      let routeUrl = this.$router.resolve({
        path: "/catalog",
      });
      window.open(routeUrl.href, "_blank");
    },
    openHome() {
      window.open("https://www.vancheen.com");
    },
    onDownload() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.prolinker.mall"
      );
    },
    loadHomeIndex() {
      let param = {};
      this.$api.customer
        .loadHomeIndex(param)
        .then((res) => {
          const data = res.data;
          this.adverts = data.AdvertList;

          var activitylist = [];
          var dayTime = [];
          for (const activity of data.ActivityNoticeList) {
            if (activity.ActivityDate) {
              dayTime.push(activity.ActivityDate);
            }
            activitylist.push(activity);
          }
          this.activitylist = activitylist;
          this.dayTime = dayTime;
          this.classList = data.ClassList;
          if (this.adverts && this.adverts.length > 0) {
            this.setSlidesOptions();
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    setSlidesOptions() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper;
        if (this.isSlidesEdit) {
          const swiperThumbsAll = this.$refs.swiperThumbsAll.$swiper;
          swiperTop.controller.control = swiperThumbsAll;
          swiperThumbsAll.controller.control = swiperTop;
          this.swiperOptionTop.loopedSlides = this.advertList.length;
          this.swiperThumbsAll.loopedSlides = this.advertList.length;
          this.swiperThumbsAll.slidesPerView = this.advertList.length;
        } else {
          const swiperThumbs = this.$refs.swiperThumbs.$swiper;
          swiperTop.controller.control = swiperThumbs;
          swiperThumbs.controller.control = swiperTop;
          this.swiperOptionTop.loopedSlides = this.adverts.length;
          this.swiperThumbs.loopedSlides = this.adverts.length;
          this.swiperThumbs.slidesPerView = this.adverts.length;
        }
      });
    },
    handleSlidesChanged(images) {
      this.slidesForm.UploadUrl = images.map((image) => {
        return image.state === "success" ? image.url : "";
      });
    },
    handleClassChanged(images) {
      this.classForm.UploadUrl = images.map((image) => {
        return image.state === "success" ? image.url : "";
      });
    },
    menuSelect(id, name) {
      let routeUrl = this.$router.resolve({
        path: "/catalog",
        query: { Name: name, Value: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    cateogrySelect(id, index) {
      this.$router.push({
        path: "/topProduct",
        query: {
          BPCId: id,
          Active: index + 2,
        },
      });
    },
    formatDate(time) {
      let [year, month, date] = time.split("/");
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      return year + "-" + month + "-" + date;
    },
    emailLink() {
      const email = "info@prolinker.top"; // 替换为你的邮箱
      location.href = `mailto:${email}`;
    },
    toFeedback() {
      this.$router.push({
        path: "/feedback",
        query: { FeedbackType: 2 },
      });
    },
    toShippingRules() {
      this.$router.push({
        path: "/shippingRules",
      });
    },
    openVancheen() {
      this.$router.replace("/home");
    },
    gotoNewHome() {
      this.$router.push("/");
    },
    gotoAminLogin() {
      this.$router.push({
        path: "/adminLogin",
      });
    },
    gotoSupplierLogin() {
      this.$router.push({
        path: "/login",
        query: { B2B: true },
      });
    },
    handleSetLanguage(lang) {
      this.setLanguage(lang);
      location.reload();
      if (lang == "en") {
        this.$message({
          message: "Switch Language Success",
          type: "success",
        });
      } else {
        this.$message({
          message: "切换语言成功",
          type: "success",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* ============================================
   PC 浏览器适配优化 - 跨浏览器兼容 + 响应式断点
   ============================================ */

.b2b-container {
  box-sizing: border-box;
  min-width: 1000px;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

::v-deep {
  .el-menu {

    .el-menu-item,
    .el-menu-item__title {
      font-size: 16px !important;
      height: 50px !important;
      line-height: 50px !important;
      padding: 0 20px !important;

      i {
        font-size: 16px !important;
      }

      .name {
        display: block;
        margin-right: 30px;

        &:hover {
          color: #01aaa3 !important;
        }
      }
    }
  }

  .el-submenu .el-submenu__title {
    font-size: 16px !important;
    height: 50px !important;
    line-height: 50px !important;
    padding: 0 20px !important;
    border: none !important;

    i {
      font-size: 16px !important;
    }

    .name {
      display: block;
      margin-right: 30px;

      &:hover {
        color: #01aaa3 !important;
      }
    }
  }
}

.menus-dropdown {
  padding: 30px 20px;

  .el-dropdown-menu__item {
    font-size: 20px;
    margin-bottom: 5px;
  }
}

.b2b-container {
  position: relative;

  .upload-desc {
    font-size: 12px;
    color: #989898;
    margin-left: 20px;

    &.wrap {
      display: block;
      line-height: 24px;
    }
  }

  /* === 1. 顶部导航 - Flexbox === */
  .b2b-navbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px 2vw 5px 0;
    gap: 0 12px;

    .switch-box,
    .admin-box,
    .supplier-box,
    .version-box {
      display: flex;
      align-items: center;
      padding-right: 16px;
      border-right: 1px solid #666;

      .switch,
      .login,
      .logout {
        font-size: 14px;
        font-weight: 300;
        color: #333;
        cursor: pointer;
        white-space: nowrap;
      }
    }

    .language-box {
      display: flex;
      align-items: center;

      .text {
        font-size: 14px;
        font-weight: 300;
        color: #333;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }

  /* === 2. 头部区域 - Flexbox === */
  .b2b-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1vw clamp(16px, 2vw, 40px);
    max-width: 1920px;
    margin: 0 auto;

    .logo {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: clamp(60px, 5vw, 80px);
        height: clamp(60px, 5vw, 80px);
      }
    }

    .menus {
      flex: 1 1 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: clamp(12px, 2vw, 32px);

      .el-dropdown {
        font-size: clamp(18px, 1.5vw, 24px);
        font-weight: bold;
        color: #1a1a1a;
        cursor: pointer;
      }

      .menus-custom-dropdown {
        display: flex;
        align-items: center;
        line-height: 50px;
        height: 50px;

        .el-menu {
          border: none;

          ::v-deep .el-submenu__title {
            .header {
              font-size: clamp(18px, 1.5vw, 24px) !important;
              color: #1a1a1a;

              &:hover {
                color: #01aaa3 !important;
              }
            }

            span {
              vertical-align: top;
            }

            i {
              display: none;
            }
          }
        }
      }

      .menus-custom {
        display: flex;
        align-items: center;
        line-height: 50px;
        height: 50px;
        padding: 0 clamp(8px, 1vw, 20px);

        .menus-arrow {
          content: "";
          display: block;
          position: absolute;
          width: 20px;
          height: 20px;
          background: #fff;
          border-right: 1px solid #e5e5e5;
          border-bottom: 1px solid #e5e5e5;
          top: 4.7%;
          transform: rotate(45deg);
          z-index: 12;
        }

        .custom-title {
          font-size: clamp(18px, 1.5vw, 24px);
          color: #1a1a1a;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            color: #01aaa3 !important;
          }
        }

        .transition-box {
          width: 100vw;
          position: absolute;
          background: #fff;
          top: 5%;
          left: 0;
          z-index: 11;
          box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);

          .activity-wrapper {
            max-width: 1400px;
            margin: 0 auto;
            min-height: 600px;
            border-top: 1px solid #e5e5e5;
            padding: clamp(16px, 2vw, 30px) 0;
            position: relative;

            .activity-title {
              color: #137c60;
              font-size: clamp(22px, 2vw, 30px);
              margin-bottom: 2%;
              text-align: left;
              padding-left: 5%;
            }

            .activity-swpier {
              width: 90%;
              max-width: 1200px;
              height: clamp(300px, 30vw, 400px);
              margin: 0 auto;
              position: relative;

              .swiper-slide {
                background-size: auto 80%;
                background-position: top;
                background-repeat: no-repeat;
                cursor: pointer;
                position: relative;

                .activity-text {
                  width: 100%;
                  position: absolute;
                  bottom: 0;
                  line-height: 25px;

                  .activity-name {
                    font-weight: bold;
                    margin-bottom: 10px;
                    font-size: clamp(14px, 1.2vw, 18px);
                    text-align: left;
                  }

                  .activity-date {
                    text-align: right;
                    font-size: clamp(13px, 1vw, 16px);
                    font-weight: 300;
                  }
                }
              }
            }

            ::v-deep .swiper-button-prev,
            ::v-deep .swiper-button-next {
              color: #777;
              width: 44px;
              border: 1px solid #777;
              border-radius: 100%;
            }

            .swiper-button-prev:after,
            .swiper-button-next:after {
              font-size: 16px;
            }

            ::v-deep .swiper-pagination {
              width: 100%;
              bottom: 2%;

              .swiper-pagination-bullet {
                width: 30px;
                height: 5px;
                margin-right: 10px;
                border-radius: 0;
              }

              .swiper-pagination-bullet-active {
                background: #137c60;
              }
            }
          }

          .consult-wrapper {
            max-width: 1400px;
            margin: 0 auto;
            border-top: 1px solid #e5e5e5;
            padding: clamp(16px, 2vw, 30px) 0;
            position: relative;

            .help {
              width: 100%;
              max-width: 1100px;
              margin: 0 auto 3%;
              display: block;

              .help-title {
                font-size: clamp(22px, 2vw, 30px);
                color: #137c60;
                margin-bottom: 2%;
              }

              .help-content {
                min-height: 400px;
                max-height: 70vh;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                background: rgb(245, 245, 245);
                padding: 0;

                .help-event {
                  cursor: pointer;
                  font-weight: bold;
                  color: red;
                }

                ::v-deep .el-collapse {
                  text-align: left;
                  margin: 3% 5%;
                  border: none;

                  .el-collapse-item__header {
                    font-size: clamp(15px, 1.2vw, 18px);
                    background: rgb(245, 245, 245);
                    border: none;

                    i {
                      color: #137c60;
                      font-weight: bold;
                    }
                  }

                  .el-collapse-item__content {
                    font-size: clamp(15px, 1.2vw, 18px);
                    background: rgb(245, 245, 245);
                    color: #999;
                  }

                  .el-collapse-item__wrap {
                    border: none;
                  }
                }
              }

              .help-empty {
                margin: 10%;
                color: #999;
                font-size: clamp(16px, 1.3vw, 20px);
              }
            }
          }

          .about-wrapper {
            max-width: 1400px;
            margin: 0 auto;
            border-top: 1px solid #e5e5e5;
            padding: clamp(16px, 2vw, 30px) 0 clamp(50px, 5vw, 100px);
            position: relative;

            .image {
              width: 90%;
              max-width: 1200px;
              margin: 0 auto;
              display: block;
              height: auto;
              min-height: 200px;
              max-height: 50vh;
              object-fit: cover;
            }

            .blocker {
              position: relative;
              width: 90%;
              max-width: 1200px;
              margin: 2vw auto 0;
              display: flex;
              flex-wrap: wrap;

              .blocker-black,
              .blocker-white,
              .blocker-green {
                flex: 1 1 280px;
                min-height: clamp(180px, 20vw, 300px);
                padding: clamp(10px, 1vw, 16px) clamp(16px, 2vw, 30px) clamp(16px, 2vw, 30px);

                .blocker-title {
                  font-size: clamp(14px, 1vw, 16px);
                  margin-bottom: 10px;
                }

                .blocker-content {
                  font-size: clamp(12px, 0.85vw, 14px);
                  line-height: 1.8;
                }
              }

              .blocker-black {
                background: rgb(30, 30, 30);
                color: #fff;
              }

              .blocker-white {
                background: #fff;
                color: #000;
              }

              .blocker-green {
                background: #137c60;
                color: #fff;
              }
            }
          }
        }
      }
    }

    .cornerBox {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;

      .searchBox {
        cursor: pointer;
        margin: auto;
        background: #137c60;
        color: #fff;
        width: 100px;
        border-radius: 50px;
        padding: 10px;
        text-align: center;

        .searchIcon {
          display: inline-block;
          margin: auto;
          white-space: nowrap;

          i {
            margin-right: 5px;
          }
        }
      }
    }
  }

  /* === 3. 主内容区 === */
  .box {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    text-align: center;

    .sec-break {
      width: 90%;
      margin: 0 auto;
      height: 2px;
      background: #e5e5e5;
    }

    /* Banner 轮播 */
    .thumb-example {
      height: clamp(400px, 55vw, 900px);
      position: relative;
      overflow: hidden;

      .buttons {
        width: 100%;
        display: block;
        text-align: center;
        margin-top: 3%;
      }

      .swiper .swiper-slide {
        background-size: clamp(900px, 65vw, 1200px) clamp(500px, 36vw, 670px);
        background-position: 28% 50%;
        background-repeat: no-repeat;
        cursor: pointer;

        .el-image {
          overflow: unset;
        }

        .title {
          width: clamp(250px, 30vw, 500px);
          text-align: left;
          z-index: 20;
          font-size: clamp(36px, 4.5vw, 72px);
          font-weight: 900;
          color: #137c60;
          position: absolute;
          right: clamp(40px, 4vw, 140px);
          top: 15%;
        }

        .titleEn {
          width: clamp(250px, 30vw, 500px);
          text-align: left;
          z-index: 20;
          font-size: clamp(36px, 4.5vw, 73px);
          font-weight: 800;
          color: #137c60;
          position: absolute;
          right: 4%;
          top: 10%;
          line-height: 1;
        }

        .desc {
          width: clamp(180px, 18vw, 270px);
          text-align: left;
          z-index: 10;
          font-size: clamp(13px, 1vw, 16px);
          font-weight: 300;
          color: #000;
          position: absolute;
          right: 10%;
          bottom: 8%;
        }

        .slides-buttons {
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 11;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;

          .slides-wrapper {
            width: 100%;
            text-align: center;

            .slides-dropdown .el-dropdown-link {
              cursor: pointer;
              color: #fff;
              font-size: clamp(24px, 2vw, 30px);
            }

            .el-button {
              vertical-align: middle;
            }
          }
        }
      }

      .swiper.gallery-top {
        height: 80%;
        width: 100%;
      }

      .swiper.gallery-thumbs {
        position: absolute;
        bottom: 16.5%;
        left: clamp(5%, 18.5%, 25%);
      }

      .swiper.gallery-thumbs .swiper-wrapper {
        transform: unset !important;
      }

      .swiper.gallery-thumbs .swiper-slide {
        height: clamp(40px, 4vw, 60px);
        border: 5px solid transparent;
        background-size: clamp(80px, 8vw, 120px) clamp(40px, 4vw, 60px);
        background-position: center;
        background-repeat: no-repeat;
      }

      .swiper.gallery-thumbs .swiper-slide:hover {
        border-color: #137c60;
        animation: thicken 0.3s forwards;
      }

      .swiper.gallery-thumbs .swiper-slide-active {
        height: clamp(40px, 4vw, 60px);
        border: 5px solid #137c60;
        background-size: clamp(80px, 8vw, 120px) clamp(40px, 4vw, 60px);
        background-position: center;
        background-repeat: no-repeat;
        animation: thicken 0.3s forwards;
      }

      .swiper.gallery-thumbs .swpier-edit {
        border-color: rgba(0, 0, 0, 0.5) !important;
      }
    }

    /* 日历 + 活动 - Flexbox */
    .calendar {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-bottom: 30px;
      padding: 0 clamp(16px, 3vw, 50px);

      .calendar-title {
        flex: 0 0 100%;
        font-size: clamp(32px, 3.5vw, 54px);
        color: #137c60;
        margin-bottom: clamp(24px, 3vw, 50px);
        text-align: center;
      }

      .calendar-left {
        flex: 1 1 45%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;

        ::v-deep .el-calendar {
          width: 80%;
          max-width: 500px;
          font-size: 14px;
          margin: 0;

          .el-calendar-day {
            height: 55px !important;
            text-align: center;
            position: relative;
          }

          .el-calendar__header {
            justify-content: space-between;
            background: #f5f7fa;
          }

          .el-calendar__body {
            text-align: center;

            .current,
            .next,
            .prev {
              border: none;
            }

            th {
              color: #c0c4cc;
            }
          }

          .el-calendar-day:hover {
            padding: 6px;
            border: 2px solid #b9dae7;
            background-color: rgb(240, 248, 255);
            color: #000;
          }

          .is-selected {
            background-color: #1890ff;
            color: #fff;
          }

          .dateText {
            margin-top: 10px;
          }

          .budge-wrapper {
            position: absolute;
            top: 120%;
            left: 42%;

            .budge {
              width: 8px;
              height: 8px;
              background: #137c60;
              border-radius: 100%;
            }
          }
        }
      }

      .calendar-right {
        flex: 1 1 45%;
        margin-left: clamp(12px, 3vw, 40px);
        display: flex;
        align-items: flex-start;

        .scroll-box {
          width: 100%;

          .scroll-title {
            font-size: clamp(20px, 1.8vw, 28px);
            color: #1a1a1a;
            font-weight: 300;
          }

          .scroll-content {
            min-height: 250px;
            max-height: 400px;
            width: clamp(300px, 60%, 500px);
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: thin;
            scrollbar-color: #c0c0c0 #f0f0f0;
            margin: 3% 0;

            .activity-select {
              color: #137c60 !important;
              font-weight: bold !important;
            }

            .activity {
              margin: 3% 0;
              color: #1a1a1a;
              display: flex;
              align-items: center;

              .left {
                flex: 0 0 72px;
                width: 72px;
                height: 72px;
                text-align: center;

                .el-image {
                  width: 72px;
                  height: 72px;
                }
              }

              .right {
                flex: 1;
                margin-left: 15px;
                font-size: 14px;

                .top {
                  margin-bottom: 10px;
                }
              }
            }
          }

          .scroll-footer .el-button {
            color: #137c60;
            border-color: #137c60;
            background: transparent;
          }
        }
      }
    }

    /* 分类 - CSS Grid */
    .category {
      margin-bottom: 5%;
      display: block;
      width: 100%;

      .category-title {
        font-size: clamp(32px, 3.5vw, 54px);
        color: #137c60;
        margin-top: clamp(24px, 3vw, 50px);
        margin-bottom: clamp(24px, 3vw, 50px);
        text-align: center;
      }

      .category-content {
        position: relative;
        text-align: center;
        padding: 2vw 0;
        
        .category-background {
          min-height: 300px;
          width: 100%;
          background: linear-gradient(10deg, #137c60, #92ac9e);
          position: absolute;
          top: 35%;
          right: 0;
        }

        .category-container {
          width: clamp(300px, 90%, 1400px);
          margin: 0 auto;
          position: relative;
          z-index: 1;

          .category-wrapper {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: clamp(8px, 1vw, 16px);
            margin-left: 0;

            .category-item,
            .category-editItem {
              position: relative;
              overflow: hidden;
              border-radius: 8px;
              cursor: pointer;
              aspect-ratio: 1/1;

              .image {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
                will-change: transform;
              }

              .image:hover {
                transform: scale(1.08);
              }
            }

            .category-item .title {
              z-index: 11;
              position: absolute;
              bottom: 8%;
              left: 8%;
              color: #fff;
              font-size: clamp(16px, 1.3vw, 23px);

              .text {
                margin-right: 8px;
                font-weight: 800;
                text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
              }

              i {
                font-weight: bold;
                text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
              }
            }

            .category-editItem .editItem-buttons {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 11;
              background-color: rgba(0, 0, 0, 0.5);
              display: flex;
              align-items: center;
              justify-content: center;

              .editItem-wrapper .editItem-dropdown .el-dropdown-link {
                cursor: pointer;
                color: #fff;
                font-size: clamp(30px, 3vw, 50px);
              }
            }
          }
        }

        .category-buttons {
          width: 100%;
          text-align: center;
          position: absolute;
          bottom:-5%;
          z-index: 1;
        }
      }
    }
  }

  /* 版权 */
  .copyright {
    text-align: center;
    padding: 20px clamp(12px, 2vw, 20px);

    .text1,
    .text2 {
      font-size: clamp(11px, 0.8vw, 12px);
      color: #000;
    }

    .text1 {
      padding-bottom: 10px;
    }

    .text2 {
      text-decoration: none;
    }
  }
}

/* 动画 */
@keyframes thicken {
  0% {
    border-width: 1px;
  }

  100% {
    border-width: 5px;
  }
}

/* 滚动条美化 */
.b2b-container .scroll-content {
  scrollbar-width: thin;
  scrollbar-color: #c0c0c0 #f0f0f0;
}

.b2b-container .scroll-content::-webkit-scrollbar {
  width: 6px;
}

.b2b-container .scroll-content::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}

.b2b-container .scroll-content::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 3px;

  &:hover {
    background: #a0a0a0;
  }
}

/* === 响应式断点 === */

/* 超大屏 ≥1920px */
@media (min-width: 1920px) {

  .b2b-container .b2b-header,
  .b2b-container .box {
    max-width: 1800px;
  }

  .b2b-container .box .thumb-example {
    height: 750px;
  }
}

/* 中屏 ≤1439px */
@media (max-width: 1439px) {
  .b2b-container .box .thumb-example {
    height: 500px;
  }

  .b2b-container .box .thumb-example .swiper .swiper-slide .title {
    font-size: 42px;
    right: 60px;
  }

  .b2b-container .box .thumb-example .swiper .swiper-slide .titleEn {
    font-size: 44px;
  }

  .b2b-container .box .thumb-example .swiper .swiper-slide .desc {
    width: 220px;
    font-size: 14px;
  }

  .b2b-container .box .category .category-wrapper {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
}

/* 小屏 ≤1279px */
@media (max-width: 1279px) {
  .b2b-container .b2b-header {
    .logo img {
      width: 60px;
      height: 60px;
    }

    .menus {
      gap: 8px;

      .menus-custom .custom-title {
        font-size: 18px;
      }

      .menus-custom-dropdown .el-menu ::v-deep .el-submenu__title .header {
        font-size: 18px !important;
      }
    }
  }

  .b2b-container .box .thumb-example {
    height: 420px;

    .swiper .swiper-slide .title {
      font-size: 36px;
      right: 40px;
      width: 280px;
    }

    .swiper .swiper-slide .titleEn {
      font-size: 36px;
      width: 280px;
    }

    .swiper .swiper-slide .desc {
      width: 200px;
      font-size: 13px;
    }

    .swiper.gallery-thumbs {
      left: 5%;
      bottom: 15%;
    }
  }

  .b2b-container .box .calendar .calendar-left ::v-deep .el-calendar {
    width: 90%;
  }

  .b2b-container .box .calendar .calendar-right .scroll-box .scroll-content {
    width: 90%;
  }

  .b2b-container .box .category .category-container {
    width: 95%;
  }

  .b2b-container .box .category .category-wrapper {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
}

/* 超小屏 ≤1023px */
@media (max-width: 1023px) {
  .b2b-container .b2b-navbar {
    padding: 5px 12px;
    gap: 0 8px;
    font-size: 13px;
  }

  .b2b-container .b2b-header {
    padding: 6px 12px;

    .logo img {
      width: 50px;
      height: 50px;
    }

    .menus {
      gap: 4px;

      .menus-custom .custom-title {
        font-size: 16px;
        padding: 0 8px;
      }

      .menus-custom-dropdown .el-menu ::v-deep .el-submenu__title .header {
        font-size: 16px !important;
      }
    }
  }

  .b2b-container .box .thumb-example {
    height: 320px;

    .swiper .swiper-slide .title {
      font-size: 28px;
      right: 20px;
      width: 220px;
      top: 30%;
    }

    .swiper .swiper-slide .titleEn {
      font-size: 28px;
      width: 220px;
    }

    .swiper .swiper-slide .desc {
      width: 180px;
      font-size: 12px;
      right: 5%;
      bottom: 5%;
    }

    .swiper.gallery-thumbs {
      display: none;
    }
  }

  .b2b-container .box .calendar {
    flex-direction: column;
    align-items: center;

    .calendar-left {
      width: 100%;
      justify-content: center;
      margin-bottom: 20px;

      ::v-deep .el-calendar {
        width: 100%;
        max-width: 400px;
      }
    }

    .calendar-right {
      width: 100%;
      margin-left: 0;

      .scroll-box .scroll-content {
        width: 100%;
        max-width: 400px;
      }
    }
  }

  .b2b-container .box .category .category-wrapper {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
}

/* 减弱动画偏好 */
@media (prefers-reduced-motion: reduce) {
  .b2b-container .category-item .image {
    transition: none;

    &:hover {
      transform: none;
      animation: none;
    }
  }
}
</style>
